import HttpService from './httpService';

const healthCheck = async () => {
  const res = await HttpService.get(`${process.env.SERVICE_DOMAIN}/health-ui-status`);
  return res;
};

const statistics = async () => {
  const res = await HttpService.get(`${process.env.SERVICE_DOMAIN}/ui/stats`);
  return res;
};

const createLink = async (data: { content: string; captcha_token: string }) => {
  const res = await HttpService.post(`${process.env.SERVICE_DOMAIN}/shortener`, data);
  return res;
};

const contactUs = async (data: { email: string; message: string }) => {
  const res = await HttpService.post(`${process.env.SERVICE_DOMAIN}/ui/contact-us`, data);

  return res;
};

const AppService = {
  healthCheck,
  statistics,
  createLink,
  contactUs,
};

export default AppService;
